import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitoimagicacab() {



    const cardData = {




keyword: "Mumbai to Imagica Cab",

headingDescription: "Shreesha Tours & Travels provides safe, comfortable, and affordable Mumbai to Imagica cab services for families, friends, couples, school groups, corporate teams, and tourists planning an exciting day trip. We offer one-way cabs, round-trip taxi services, same-day return packages, airport transfers, and customized outstation travel with experienced chauffeurs and well-maintained vehicles. Our fleet includes Sedan, Swift Dzire, Ertiga, SUV, Innova, Innova Crysta, Tempo Traveller, Urbania, Mini Bus, and luxury vehicles suitable for every group size and travel requirement. With doorstep pickup anywhere in Mumbai, flexible departure timings, transparent pricing, easy online booking, and 24/7 customer support, Shreesha Tours & Travels ensures a safe, smooth, and hassle-free journey. Whether you are planning a family outing, children's vacation, birthday celebration, school excursion, corporate event, or weekend getaway, our Mumbai to Imagica cab service offers clean vehicles, courteous drivers, and a comfortable travel experience. Enjoy a scenic drive via the Mumbai–Pune Expressway and reach Imagica conveniently to make the most of your fun-filled day.",

topPlaces: [
  {
    title: "Imagica Theme Park",
    description: "Imagica Theme Park is one of India's largest amusement parks, featuring world-class roller coasters, family rides, children's attractions, live entertainment, themed zones, and exciting adventures. It is the perfect destination for families, couples, friends, and thrill seekers of all ages."
  },
  {
    title: "Imagica Water Park",
    description: "Imagica Water Park offers thrilling water slides, wave pools, lazy rivers, splash zones, rain dance areas, and family-friendly attractions. It is an ideal place to beat the heat and enjoy a refreshing day filled with fun and adventure."
  },
  {
    title: "Novotel Imagica Khopoli",
    description: "Novotel Imagica is a premium resort located beside the theme park, offering luxurious accommodation, fine dining, spa facilities, swimming pools, and easy access to all Imagica attractions. It is perfect for weekend holidays and family vacations."
  },
  {
    title: "Khopoli",
    description: "Khopoli is a picturesque town nestled in the Sahyadri Hills, known for its scenic landscapes, waterfalls, temples, and pleasant climate. It serves as the gateway to Imagica and several popular tourist destinations in the region."
  },
  {
    title: "Pali Ballaleshwar Temple",
    description: "Pali Ballaleshwar Temple is one of the sacred Ashtavinayak Ganpati temples located near Imagica. Devotees often combine a visit to this revered temple with their trip to enjoy both spiritual and recreational experiences."
  },
  {
    title: "Zenith Waterfall",
    description: "Zenith Waterfall is a beautiful natural attraction near Khopoli, especially popular during the monsoon season. Surrounded by lush greenery and rocky landscapes, it is a favorite spot for photography, picnics, and nature lovers."
  },
  {
    title: "Karla Caves",
    description: "Karla Caves are ancient Buddhist rock-cut caves located within driving distance of Imagica. Famous for their magnificent Chaitya Hall and intricate carvings, they attract history enthusiasts, pilgrims, and architecture lovers."
  },
  {
    title: "Lonavala",
    description: "Lonavala is one of Maharashtra's most famous hill stations, offering scenic viewpoints, waterfalls, lakes, caves, forts, and pleasant weather. Many travelers combine Imagica and Lonavala in a single weekend trip."
  },
  {
    title: "Khandala",
    description: "Khandala is a beautiful hill station known for panoramic viewpoints, lush green valleys, waterfalls, and peaceful surroundings. Located close to Imagica, it is an excellent destination for sightseeing and relaxation."
  },
  {
    title: "Pawna Lake",
    description: "Pawna Lake is a popular lakeside destination near Lonavala, famous for camping, boating, photography, and stunning sunset views. It is an ideal place for families, couples, and groups looking to extend their Mumbai to Imagica road trip with a peaceful nature experience."
  }
],



"services": [
  {
    "name": "Mumbai to Imagica Cab",
    "description": "Book Mumbai to Imagica Cab for a safe, comfortable, and enjoyable journey to Imagica Theme Park with professional chauffeurs and well-maintained AC vehicles. Choose from Sedan, Ertiga, Innova, Innova Crysta, SUV, and Tempo Traveller options for family outings, corporate events, school trips, and weekend vacations with flexible one way and round trip booking."
  },
  {
    "name": "Mumbai to Imagica Taxi",
    "description": "Hire Mumbai to Imagica Taxi for reliable and hassle-free transportation with experienced drivers, clean vehicles, and affordable pricing. Enjoy convenient pickup, smooth highway travel, and comfortable rides suitable for families, couples, and groups."
  },
  {
    "name": "Mumbai to Imagica Cab Service",
    "description": "Choose Mumbai to Imagica Cab Service for premium outstation travel with professional chauffeurs, spacious vehicles, and transparent pricing. Travel comfortably with flexible schedules for family holidays, business outings, and theme park visits."
  },
  {
    "name": "Mumbai to Imagica Taxi Service",
    "description": "Book Mumbai to Imagica Taxi Service with reliable drivers, comfortable AC vehicles, and convenient pickup from any location in Mumbai. Enjoy safe and stress-free transportation for one day trips and weekend getaways."
  },
  {
    "name": "Mumbai to Imagica Cab Booking",
    "description": "Complete Mumbai to Imagica Cab Booking online with instant confirmation, multiple vehicle choices, and competitive pricing. Select the ideal cab according to your group size and travel requirements."
  },
  {
    "name": "Mumbai to Imagica Car Rental",
    "description": "Hire Mumbai to Imagica Car Rental with chauffeur-driven vehicles for comfortable and private travel. Choose premium cabs suitable for family vacations, tourist groups, and corporate outings."
  },
  {
    "name": "Mumbai to Imagica Taxi Fare",
    "description": "Check Mumbai to Imagica Taxi Fare with transparent pricing and affordable travel packages. Enjoy quality vehicles, experienced drivers, and reliable transportation without hidden charges."
  },
  {
    "name": "Mumbai to Imagica Cab Fare",
    "description": "Get the best Mumbai to Imagica Cab Fare with flexible one way and round trip packages. Travel comfortably with professional drivers and well-maintained vehicles at competitive prices."
  },
  {
    "name": "Mumbai to Imagica One Way Cab",
    "description": "Book Mumbai to Imagica One Way Cab for economical single-trip travel with fixed pricing, comfortable seating, and experienced chauffeurs. Ideal for passengers looking for affordable point-to-point transportation."
  },
  {
    "name": "Mumbai to Imagica Round Trip Taxi",
    "description": "Choose Mumbai to Imagica Round Trip Taxi for convenient same-day return travel with flexible waiting time, affordable packages, and professional chauffeur service."
  },
  {
    "name": "Mumbai Airport to Imagica Cab",
    "description": "Reserve Mumbai Airport to Imagica Cab with timely airport pickup, comfortable AC vehicles, and experienced drivers. Enjoy direct transportation from Mumbai Airport to Imagica Theme Park without delays."
  },
  {
    "name": "Navi Mumbai to Imagica Cab",
    "description": "Book Navi Mumbai to Imagica Cab for comfortable and reliable travel with professional drivers, clean vehicles, and affordable fares for family trips and weekend outings."
  },
  {
    "name": "Thane to Imagica Taxi",
    "description": "Hire Thane to Imagica Taxi for safe and convenient travel with experienced chauffeurs, spacious vehicles, and flexible pickup timings for enjoyable theme park visits."
  },
  {
    "name": "Mumbai to Imagica Outstation Cab",
    "description": "Choose Mumbai to Imagica Outstation Cab for dependable long-distance transportation with AC vehicles, skilled drivers, and flexible travel options suitable for personal and group travel."
  },
  {
    "name": "Mumbai to Imagica Tour Cab",
    "description": "Book Mumbai to Imagica Tour Cab for sightseeing and entertainment trips with comfortable vehicles, experienced chauffeurs, and customized travel plans for families and tourist groups."
  },
  {
    "name": "Mumbai to Imagica Family Trip Cab",
    "description": "Reserve Mumbai to Imagica Family Trip Cab with spacious seating, large luggage space, and comfortable travel for family vacations, children's outings, and holiday trips."
  },
  {
    "name": "Mumbai to Imagica Weekend Trip Cab",
    "description": "Choose Mumbai to Imagica Weekend Trip Cab for relaxing weekend travel with flexible schedules, reliable drivers, and premium vehicles designed for enjoyable road trips."
  },
  {
    "name": "Mumbai to Imagica Theme Park Taxi",
    "description": "Book Mumbai to Imagica Theme Park Taxi for direct transportation with safe driving, comfortable seating, and timely pickup and drop services for a memorable day at Imagica."
  },
  {
    "name": "Mumbai to Imagica Innova Cab",
    "description": "Hire Mumbai to Imagica Innova Cab for spacious family travel with comfortable seating, professional chauffeurs, and smooth highway performance suitable for group outings."
  },
  {
    "name": "Mumbai to Imagica Innova Crysta Cab",
    "description": "Reserve Mumbai to Imagica Innova Crysta Cab for premium travel with luxury seating, ample luggage capacity, and experienced chauffeurs. Ideal for family tours and corporate travel."
  },
  {
    "name": "Mumbai to Imagica Ertiga Cab",
    "description": "Choose Mumbai to Imagica Ertiga Cab for affordable 6 to 7 seater travel with spacious interiors and comfortable seating. Perfect for families and small groups visiting Imagica."
  },
  {
    "name": "Mumbai to Imagica Sedan Cab",
    "description": "Book Mumbai to Imagica Sedan Cab for economical and comfortable travel with clean AC vehicles and professional drivers. Suitable for couples, solo travelers, and business trips."
  },
  {
    "name": "Mumbai to Imagica SUV Cab",
    "description": "Hire Mumbai to Imagica SUV Cab for premium road trips with spacious interiors, powerful performance, and comfortable seating for families and larger travel groups."
  },
  {
    "name": "Best Mumbai to Imagica Cab Booking",
    "description": "Choose the Best Mumbai to Imagica Cab Booking for reliable service, experienced chauffeurs, premium vehicles, affordable fares, and hassle-free online reservations. Enjoy a comfortable and memorable journey with professional customer support and flexible travel options."
  }
],
"tableData": [
  ["Mumbai to Imagica Cab", "Mumbai to Imagica Taxi"],
  ["Mumbai to Imagica Cab Service", "Mumbai to Imagica Taxi Service"],
  ["Mumbai to Imagica Cab Booking", "Mumbai to Imagica Car Rental"],
  ["Mumbai to Imagica Taxi Fare", "Mumbai to Imagica Cab Fare"],
  ["Mumbai to Imagica One Way Cab", "Mumbai to Imagica Round Trip Taxi"],
  ["Mumbai Airport to Imagica Cab", "Navi Mumbai to Imagica Cab"],
  ["Thane to Imagica Taxi", "Mumbai to Imagica Outstation Cab"],
  ["Mumbai to Imagica Tour Cab", "Mumbai to Imagica Family Trip Cab"],
  ["Mumbai to Imagica Weekend Trip Cab", "Mumbai to Imagica Theme Park Taxi"],
  ["Mumbai to Imagica Innova Cab", "Mumbai to Imagica Innova Crysta Cab"],
  ["Mumbai to Imagica Ertiga Cab", "Mumbai to Imagica Sedan Cab"],
  ["Mumbai to Imagica SUV Cab", "Best Mumbai to Imagica Cab Booking"]
],




whychoose: [
  {
    WhyChooseheading: "Exciting Mumbai to Imagica Cab for a Fun-Filled Day",
    WhyChoosedescription: "Turn your trip to Imagica into a comfortable experience with Shreesha Tours & Travels. Our Mumbai to Imagica cab service is perfect for families, friends, school groups, couples, and corporate outings."
  },
  {
    WhyChooseheading: "Convenient Pickup from Any Location in Mumbai",
    WhyChoosedescription: "Start your journey with doorstep pickup from your home, hotel, office, railway station, airport, or any preferred location and travel directly to Imagica without changing vehicles."
  },
  {
    WhyChooseheading: "Comfortable Cars for Every Group Size",
    WhyChoosedescription: "Choose from Swift Dzire, Sedan, Ertiga, Innova, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles depending on your group size and travel preferences."
  },
  {
    WhyChooseheading: "Ideal for Families, Friends & Corporate Outings",
    WhyChoosedescription: "Whether you're planning a weekend adventure, birthday celebration, school picnic, office outing, or family vacation, our Mumbai to Imagica taxi service makes the journey enjoyable."
  },
  {
    WhyChooseheading: "Professional Drivers with Expressway Experience",
    WhyChoosedescription: "Our experienced chauffeurs are familiar with the Mumbai–Khopoli Expressway route, ensuring a safe, smooth, and timely drive to Imagica."
  },
  {
    WhyChooseheading: "One Way, Round Trip & Full-Day Cab Packages",
    WhyChoosedescription: "Book a one-way transfer, same-day return taxi, or full-day cab package with waiting time so you can enjoy Imagica at your own pace."
  },
  {
    WhyChooseheading: "Clean, Air-Conditioned & Well-Maintained Vehicles",
    WhyChoosedescription: "Travel comfortably in hygienic, regularly serviced vehicles with spacious seating and sufficient luggage space for a pleasant road trip."
  },
  {
    WhyChooseheading: "Easy Mumbai to Imagica Cab Booking",
    WhyChoosedescription: "Shreesha Tours & Travels offers transparent pricing, quick booking confirmation, and dependable customer support for a hassle-free Imagica travel experience."
  }
]

};

const faqData = [
  {
    question: "Can I book a private cab from Mumbai to Imagica for a same-day trip?",
    answer: "Yes, same-day return and full-day cab packages are available for travellers visiting Imagica from Mumbai."
  },
  {
    question: "Do you provide waiting time while we enjoy Imagica?",
    answer: "Yes, full-day taxi packages with driver waiting options can be arranged based on your booking."
  },
  {
    question: "Which vehicles are available for Mumbai to Imagica travel?",
    answer: "You can book Swift Dzire, Sedan, Ertiga, Innova, Innova Crysta, SUVs, Tempo Travellers, and luxury vehicles."
  },
  {
    question: "Is the cab suitable for school and corporate group outings?",
    answer: "Yes, larger vehicles and Tempo Travellers are available for school trips, corporate events, and group excursions."
  },
  {
    question: "Can I schedule an early morning pickup from Mumbai?",
    answer: "Yes, pickups can be arranged early in the morning according to your preferred departure time."
  },
  {
    question: "Do you provide pickup from Mumbai Airport or hotels?",
    answer: "Yes, pickup is available from Mumbai Airport, hotels, railway stations, offices, homes, and other convenient locations."
  },
  {
    question: "Can I book a one-way taxi to Imagica?",
    answer: "Yes, one-way transfers, return journeys, and customized travel packages are available."
  },
  {
    question: "How is the Mumbai to Imagica cab fare calculated?",
    answer: "The fare depends on the vehicle category, trip type, travel duration, and whether you choose one-way or round-trip service."
  },
  {
    question: "Is advance booking recommended for weekends and holidays?",
    answer: "Yes, advance booking is highly recommended during weekends, public holidays, and vacation seasons due to high travel demand."
  },
  {
    question: "How do I reserve a Mumbai to Imagica Cab with Shreesha Tours & Travels?",
    answer: "Simply share your travel date, pickup location, passenger count, preferred vehicle, and trip type to receive your quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Harsh Vora",
    feedback: "Our family booked an Innova Crysta for a day trip to Imagica. The driver arrived on time, the vehicle was spotless, and the return journey was just as comfortable as the onward trip.",
    rating: 5
  },
  {
    id: 2,
    name: "Ms. Snehal Patankar",
    feedback: "We travelled with friends from Mumbai to Imagica in a Tempo Traveller. The booking process was smooth, the vehicle was spacious, and Shreesha Tours & Travels made our outing completely hassle-free.",
    rating: 5
  }
];




















    const Images = [
        { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
        { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
        { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
        { place: "/images/keyword/5.jpg", text: "Mumbai to Nashik Cab", link: "Mumbai-to-Nashik-Cab" },
        { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
        { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
        { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
        { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
        { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
        { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
        { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
        { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
        { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
        { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
        { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
        { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
        { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
        { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
        { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
        { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
        { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
        { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
        { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
    ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Imagica Cab",
  "image": "https://www.shreeshatravels.com/assets/images/mumbai-to-imagica-cab.webp",
  "description":
    "Book Mumbai to Imagica Cab with Shreesha Tours & Travels for safe, comfortable, and affordable outstation taxi services. We provide one-way and round-trip cabs from Mumbai to Imagica Theme Park with Sedan, Ertiga, SUV, Innova, and Innova Crysta available 24x7 for family outings, weekend trips, group travel, corporate events, and amusement park visits.",
  "brand": {
    "@type": "Brand",
    "name": "Shreesha Tours & Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shreeshatravels.com/mumbai-to-imagica-cab"
  }
};




    return (
        <div>

<Helmet>
  <title>Mumbai to Imagica Cab | Theme Park Taxi | +91 8355835813</title>

  <meta
    name="description"
    content="Book Mumbai to Imagica Cab with Shreesha Travels for reliable one-way and round-trip taxi services. Hire Sedan, Ertiga, SUV, Innova, and Innova Crysta for affordable travel from Mumbai to Imagica with 24x7 online cab booking and experienced drivers."
  />

  <meta
    name="keywords"
    content="Mumbai to Imagica Cab, Mumbai to Imagica Taxi, Mumbai to Imagica Cab Service, Mumbai to Imagica Taxi Service, Mumbai to Imagica One Way Cab, Mumbai to Imagica Round Trip Cab, Mumbai to Imagica Cab Booking, Mumbai to Imagica Taxi Booking, Mumbai to Imagica Car Rental, Mumbai to Imagica Outstation Cab, Imagica Cab from Mumbai, Mumbai to Imagica Theme Park Taxi"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/31.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Shreesha Tours & Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Shreesha Tours & Travels</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shreesha Tours & Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918355835813 " className="pc-call">+91 8355835813 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919930929439 " className="pc-call">+91 9930929439 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919022432779 " className="pc-call">+91 9022432779 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91919930929439 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918355835813 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@shreeshatravels.com" className="pc-email">
                                            booking@shreeshatravels.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Shreesha Tours & Travels</strong><br />
                                            Office 125, Saishraddha CHS,
                                            Plot No 47, Near Koparkhairane Police Station,
                                            Sector 5, Sector 4,Ghansoli, Navi Mumbai,
                                            Maharashtra, India- 400701




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Mumbaitoimagicacab;